import {
 ref, watch, computed, onMounted,
} from '@vue/composition-api'

import {
  arr1, arr2, task1, extraMessage, finish,
} from './arrs'
import { pushPopup } from '@/utils/pushPopup'

export default {
  name: 'step22',
  components: {},
  setup(_, { emit }) {
    const popups = ref([])
    const inputVal = ref('')
    const errInput = ref(false)

    const completedGraph = ref({
      graph1: false,
      graph2: false,
      graph3: false,
    })

    const step = ref({
      start: false,
    })

    const sliderValue1 = ref(1)
    const sliderValue2 = ref(1)
    const sliderValue3 = ref(1)

    const material = {
      svg: null,
      keyGraph: null,

      // иницилизация самой свг
      init(svgId, currentGz) {
        const svgProxy = document.querySelector(`${svgId}`)
        this.svg = svgProxy
        this.changePaths(currentGz)
      },

      changePaths(num) {
        const gSvg = this.svg.querySelector('.pth')
        gSvg.innerHTML = ''

        let start = 79
        const interval = 72

        // eslint-disable-next-line
        for (let i = 0; i <= 18 * num; i++) {
          if (i && i < (18 * num - num + 1)) start += interval / num
          gSvg.innerHTML += `<path d="M${start} 260L${start} -0.000378773" stroke="white"/>`
        }
        this.modePaths(gSvg)
      },

      modePaths(gSvg) {
        const circles = [...this.svg.querySelectorAll('circle')]
        const paths = [...gSvg.querySelectorAll('path')]
        const pathsMode = []
        paths.forEach((e) => {
          const [coordPath] = e.attributes.d.value.split(' ')
          const coordPathProxy = Number(coordPath.match(/\d+/)[0])
          circles.forEach((circ) => {
            if (Number(circ.attributes.cx.value) === coordPathProxy) e.setAttribute('stroke-width', 4)
          })
          if (e.attributes['stroke-width']) pathsMode.push(true)
        })

        const everyValid = []

        if (pathsMode.length === circles.length) {
          completedGraph.value[this.keyGraph] = true

          // eslint-disable-next-line
          for (const key in completedGraph.value) {
            everyValid.push(completedGraph.value[key])
          }

          if (everyValid.every(e => e)) pushPopup(arr2, popups.value)
        }
      },
    }

    onMounted(() => {
      material.init('.graph1', sliderValue1.value)
      material.init('.graph2', sliderValue2.value)
      material.init('.graph3', sliderValue3.value)
    })

    watch(sliderValue1, () => {
      material.keyGraph = 'graph1'
      material.init('.graph1', sliderValue1.value)
    })

    watch(sliderValue2, () => {
      material.keyGraph = 'graph2'
      material.init('.graph2', sliderValue2.value)
    })

    watch(sliderValue3, () => {
      material.keyGraph = 'graph3'
      material.init('.graph3', sliderValue3.value)
    })

    const init = () => {
      pushPopup(arr1, popups.value)
    }
    init()

    let stage = 0

    const nextStep = () => {
      popups.value = []

      stage += 1

      if (stage === 1) {
        pushPopup(extraMessage, popups.value)
      } else if (stage === 2) {
        step.value.start = true
      }
    }

    watch(inputVal, () => {
      if (inputVal.value === '2') {
        popups.value = []
        pushPopup(finish, popups.value)
        setTimeout(() => {
          emit('nextStep', 3)
        }, 1500)
        return
      }
      if (inputVal.value) {
        errInput.value = true
        setTimeout(() => {
          inputVal.value = ''
          errInput.value = false
        }, 700)
      }
    })

    const getDiscredit = (val, index) => {
      if (index === 0) return computed(() => val * 1333)

      if (index === 1) return computed(() => val * 1800)

      return computed(() => val * 2800)
    }

    return {
      task1,

      sliderValue1,
      sliderValue2,
      sliderValue3,
      completedGraph,
      popups,
      step,
      inputVal,
      errInput,
      getDiscredit,
      nextStep,
    }
  },
}
